import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { COLLECTIONS_BD } from 'app/core/models/collections.model';
import { DbService } from 'app/core/services/db.service';
import { Menu } from 'app/menu/models/menu.model';
import { Restaurant } from 'app/menu/models/restaurants.model';
import { MenuStorageService } from 'app/menu/services/menu-storage.service';

@Component({
    selector: 'app-partners',
    templateUrl: './partners.component.html',
    styleUrls: ['./partners.component.scss'],
    standalone: false
})
export class PartnersComponent implements OnInit {
  dialogClass = 'my-dialog';

  /**
   * Informacion del restaurante actual
   */
  restaurant: Restaurant = {} as Restaurant;
  /**
   * Informacion del menu seleccionado
   */
  menu: Menu = {} as Menu;
  /**
   * Listado de aliados
   */
  listPartners: Restaurant[] = [];
  constructor(
    public dialogRef: MatDialogRef<PartnersComponent>,
    private db: DbService,
    private menuStorage: MenuStorageService
  ) { }

  ngOnInit(): void {
    this.getRestaurant();
    this.getMenu();
    this.loadPartners();
  }


  /**
   * Carga la lista de restaurantes que pertenencen
   * al mismo grupo por idClient
   */
  loadPartners(): void {
    this.db.get(`${COLLECTIONS_BD.restaurants}`,
      ['idClient', '==', this.restaurant.idClient])
      .subscribe((partners: Restaurant[]) => {
        this.listPartners = partners;
      });
  }

  /**
   * Obtiene el menu seleccionado
   */
  getMenu(): void {
    this.menuStorage.getMenu().subscribe((m: Menu) => {
      this.menu = m;
      setTimeout(() => {
        const outlines: any = document.getElementsByClassName('mat-dialog-container');
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (let index = 0; index < outlines.length; index++) {
          outlines[index].style.backgroundColor = this.menu.color;
          if (m.background && m.background !== '') {
            outlines[index].style.backgroundImage = 'url(' + m.background + ')';
          }
        }
      }, 100);
    });
  }

  /**
   * Obtiene el restaurante actual
   */
  getRestaurant(): void {
    this.menuStorage.getRestaurant().subscribe((r: Restaurant) => {
      this.restaurant = r;
    });
  }

  /**
   * Se encarga de cerrar el modal
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Establece el link de instagram
   */
  linkInstagram(partner: Restaurant): string {
    if (partner.instagram !== '') {
      return `https://www.instagram.com/${partner.instagram}/`;
    }
    return '';
  }
  /**
   * Establece el link de whatsapp
   */
  linkWs(partner: Restaurant): string {
    if (partner.phone !== '') {
      return `https://api.whatsapp.com/send?phone=${partner.phone}`;
    }
    return '';
  }

  /**
   * Establece el link de direccion para abrir google maps
   */
  linkAddress(partner: Restaurant): string {
    if (partner.address !== '') {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(partner.address)}`;
    }
    return '';
  }

}
